import { useTranslation } from "@/hooks/useTranslation"
import { DescriptiveSelect } from "@/molecules/DescriptiveSelect"
import { Form } from "@/organisms/Form"
import { useAiPolicyMcpServers } from "@/pages/GovernancePage/applications/ai-policies/useLiveAiPolicies"
import {
  getMcpScopeError,
  getMcpServerScopeOptions
} from "@/pages/GovernancePage/applications/ai-policies/useLiveAiPolicies.selector"

import type { Rule } from "@/atoms"
import type { LiveMcpScopeResourcesProps } from "./LiveMcpScopeResources.types"

const SCOPE_LIST = "specific_resources"
const MCP_SERVER = "mcpServer"

// An MCP server policy's specific servers: only remote ones can be picked, and
// each other one says why not
export const LiveMcpScopeResources = ({
  saved
}: LiveMcpScopeResourcesProps) => {
  const { t } = useTranslation()
  const { isLoading, servers } = useAiPolicyMcpServers()
  const rules: Rule[] = [
    { required: true, message: t("error.requiredField") },
    {
      validator: async (_, names: string[] | undefined) => {
        const error = getMcpScopeError(t, names ?? [], servers, saved)

        if (error) throw new Error(error)
      }
    }
  ]
  const options = getMcpServerScopeOptions(t, servers)

  return (
    <>
      <Form.Item
        hidden
        name={[SCOPE_LIST, 0, "type"]}
        initialValue={MCP_SERVER}
      />
      <Form.Item
        name={[SCOPE_LIST, 0, "value"]}
        rules={rules}
        data-testid="mcp-servers"
      >
        <DescriptiveSelect<string>
          mode="multiple"
          loading={isLoading}
          aria-label={t("governance.ai.live.form.mcpResources.label")}
          placeholder={t("governance.ai.live.form.mcpResources.placeholder")}
          optionFilterProp="label"
          values={options}
        />
      </Form.Item>
    </>
  )
}
